import React from "react";
import ApplyNowButton from "../../../../../components/applynowbutton";

const OutcomesYEI = () => {
  return (
    <div
      className=" py-10 mt-5 rounded-lg bg-gray-900 text-white relative"
      id="outcomes"
    >
      <div className="absolute inset-0 bg-black bg-opacity-50 z-10 rounded-lg"></div>
      <div className="h-full flex items-center justify-center relative z-20 px-10 text-center">
        <div className="max-w-4xl">
          <h2 className="md:text-3xl text-lg font-bold mb-4">
            Programme Progression
          </h2>
          <div className="bg-sdorange h-1 w-10 mx-auto mb-4"></div>

          <p className="md:text-lg text-base leading-relaxed text-justify">
            Graduates of this programme are eligible to advance to: <br />{" "}
            <br /> 1. Postgraduate Diploma in Advanced International Relations
            and Diplomatic Practice (60 ECTS).
            <br />
            <br />
            The programme lays the foundation for advanced studies in diplomacy,
            equipping participants with skills necessary for higher-level
            academic and professional achievements
          </p>
        </div>
      </div>
      <div
        className="absolute inset-0 bg-cover bg-center rounded-lg"
        style={{ backgroundImage: "url('/image-fix/random-images/r6.jpg')" }}
      ></div>
      <ApplyNowButton />
    </div>
  );
};

export default OutcomesYEI;
